import { useEffect, useState } from 'react'

type Key = keyof Window['INITIAL_STATE']

export const useInitialState = <K extends Key>(key: K) => {
  const [initialState, setInitialState] = useState<Window['INITIAL_STATE'][K] | null>(null)
  useEffect(() => {
    if (window.INITIAL_STATE && window.INITIAL_STATE[key]) {
      setInitialState(window.INITIAL_STATE[key])
    }
  }, [])
  return initialState
}
